import {
  formControlLabelClasses,
  inputLabelClasses,
  SxProps,
  Theme,
  typographyClasses,
} from '@mui/material'
import { grey } from '@mui/material/colors'

export const headerStyle: Record<string, SxProps<Theme>> = {
  appBar: {
    zIndex: (theme) => theme.zIndex.appBar + 1,
    bgcolor: 'common.white',
    boxShadow: 'none',
  },
  toolbar: {
    justifyContent: {
      xs: 'center',
      sm: 'left',
    },
  },
  iconBar: {
    position: 'absolute',
    right: 10,
    display: 'flex',
  },
}

export const layoutForErrorsStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100vw',
  height: '100vh',
}

export const switchersStyle: SxProps = {
  padding: '8px 10px',
  margin: '4px 0 4px 8px',
  color: 'rgba(0, 0, 0, 0.23)',
}

export const switcherSubheadingStyle: SxProps = {
  fontSize: '12px',
  color: 'text.secondary',
  wordBreak: 'break-word',
}

export const switcherLabelWithImageStyle: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  minWidth: (theme) => `calc(50% - ${theme.spacing(1)})`,
  flexBasis: (theme) => `calc(50% - ${theme.spacing(1)})`,
  paddingRight: 0,
  [`.${formControlLabelClasses.label}`]: {
    display: 'block',
    width: '100%',
    height: '100%',
    paddingLeft: 0,
  },
}

export const switcherWithSubheadingPrivateSwitchBase: SxProps = {
  '& .PrivateSwitchBase-root': {
    alignSelf: 'baseline',
  },
}

export const textFieldPickerStyle: SxProps<Theme> = {
  '& label': {
    wordBreak: 'inherit',
    // 48px is the width of the date and time picker inputs icons
    maxWidth: () => 'calc(100% - 48px)',

    [`.${inputLabelClasses.asterisk}`]: {
      position: 'absolute',
      right: 0,
    },
  },
}

export const mainButtonStyle: Record<string, SxProps> = {
  button: {
    fontSize: '15px',
    width: '100%',
    height: {
      xs: '40px',
      sm: '42px',
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export const absCenter: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}

export const formWrapStyles: Record<string, SxProps<Theme>> = {
  container: {
    flexGrow: 1,
    pt: {
      xs: '88px',
      sm: '0px',
    },
    pb: (theme) => theme.spacing(6),
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 480,
    margin: '0 auto',
    gap: (theme) => theme.spacing(3),
  },
}

export const fieldsetBorder: SxProps<Theme> = {
  borderRadius: '8px',
  border: (theme) => `1px solid ${theme.palette.primary.main}`,
}

export const cancelBtnStyle: SxProps = {
  color: grey[700],
  '&:hover': {
    backgroundColor: grey[100],
  },
}

export const deleteBtnStyle: SxProps = {
  color: 'error.main',
  borderColor: 'error.main',
  '&: hover': {
    color: 'white',
    backgroundColor: 'error.light',
    borderColor: 'white',
  },
}

export const selectionSetStyle: Record<string, SxProps> = {
  width100: {
    width: '100%',
  },
  variantTextWrap: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  variantText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '42px',
    padding: '0 6px 0',
    textAlign: 'center',
    boxSizing: 'content-box',
    textTransform: 'uppercase',
  },
}

export const selectionRowStyle: Record<string, SxProps> = {
  groupWrap: {
    gap: 1.5,
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexWrap: 'nowrap',
  },
  controlLabel: {
    minWidth: 'fit-content',
    flexBasis: 'auto',
    border: 'none',
    [`.${typographyClasses.root}`]: {
      display: 'none',
    },
  },
}
